import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationAddModelComponent } from '../organization-add-model/organization-add-model.component';
import { Router } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { UtilityService } from '../../core/global/utility.service';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.sass']
})
export class OrganizationComponent implements OnInit {
  orgList = [];
  deleteID = '';
  modalConfirmation;
  searchInput: any = '';
  sortedtby: any = 'id';
  page: number = 1; // Enter 1 if you want to use the server side pagination 
  p;
  password
  pass
  last
  totalPages=[]
  limit=10
  count
  userType: string;
  constructor(private modalService: NgbModal, private _adminService: ApiService, private _utility: UtilityService) { }
  ngOnInit(): void {
    this.userType = localStorage.getItem('m_ind_type');
    this.getOrg();
  }
  getOrg() {
    let url = "qr/org_list";
    let data = { searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    this._utility.showLoader();
    this._adminService.post(url, data).subscribe((response) => {
      this._utility.hideLoader();
      if (response.status == 200) {
        this.orgList = response.data;
        this.count = response.total;
        this.limit = response.limit;
        for (var j = 0; j < response.pages; j++) {
          this.totalPages[j] = j + 1;
        }
        this.last = response.pages;
      } else {
        this._utility.toastError(response.message);
      }
    })
  }

  searchChanged(){
    this.page = 1;
    this.getOrg();
   
  }
  orgModal(Id) {
    window.localStorage.setItem('pushOrgId', Id);
    const modalRef = this.modalService.open(OrganizationAddModelComponent, { centered: true, backdrop: "static", size: 'lg' }); // xl, lg , sm
    modalRef.result.then((result) => {
      this.getOrg();
    }, (reason) => {
      //
    });
  }
  confirmModal(content, id) {
    this.deleteID = id;
    this.modalConfirmation = this.modalService.open(content, { centered: true });
    this.modalConfirmation.result.then((result) => {
      //this.getOrg('');
    }, (reason) => {
      //
    });
  }

  closeconfirm(param, id) {
    if (param == 'yes') {
      let url = 'qr/org_remove';
      let data = { 'id': this.deleteID }
      this._adminService.delete(url, data).subscribe((response) => {
        //this.spinnerService.hide();
        if (response.success == true) {
          this.getOrg();
          this._utility.toastSuccess(response.message);
        } else {
          this._utility.toastError(response.message);
        }
        this.modalConfirmation.close();
      })

    } else {
      this.modalConfirmation.close();
    }

  }

}
